import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasAnyPermission, isAdmin, useAuthStore } from '@/stores/authStore';

interface Props {
  children: ReactNode;
  /** Requires the user to have the `admin` role slug. */
  requireAdmin?: boolean;
  /**
   * Requires the user to have AT LEAST ONE of the listed permissions.
   * Use this in combination with — or instead of — `requireAdmin` for
   * fine-grained gating (e.g. `['users.read', 'audit.read']`).
   */
  requirePermissions?: string[];
}

export function ProtectedRoute({
  children,
  requireAdmin = false,
  requirePermissions,
}: Props) {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!token || !user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (requireAdmin && !isAdmin(user)) {
    return <Navigate to="/app/dashboard" replace />;
  }
  if (requirePermissions && !hasAnyPermission(user, requirePermissions)) {
    return <Navigate to="/app/dashboard" replace />;
  }
  return <>{children}</>;
}
